import React, { Component } from 'react';
import classes from "./DataTable_Villager_Board.module.css";
import DataTable_Villager from './DataTable_Villager';

export default class DataTable_Villager_Board extends Component {

    render() {
        return (
            <div className={classes.container}>              
                <h4>Villagers and their Characteristics</h4>
                <p>Filter (by using the Search box) by Name, Gender, Personality or other attribute. Click on the headings to Sort by ascending or descending order.</p>    
                <DataTable_Villager />
            </div>
        )
    }
}